import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activePhotoAlbum,
  createPhotoAlbum,
  deletePhotoAlbum,
  getPhotoAlbum,
  inactivePhotoAlbum,
  listPhotoAlbum,
  updatePhotoAlbum,
} from 'api/setting/photo-album.api';
import {
  ActivePhotoAlbumRequestModel,
  DeletePhotoAlbumRequestModel,
  GetPhotoAlbumRequestModel,
  InactivePhotoAlbumRequestModel,
  ListPhotoAlbumRequestModel,
  SavePhotoAlbumRequestModel,
} from 'models/setting/photo-album.model';

export const getPhotoAlbumAction = createAsyncThunk(
  'GET_PHOTO_ALBUM_REQUEST',
  async (payload: GetPhotoAlbumRequestModel) => getPhotoAlbum(payload),
);

export const listPhotoAlbumAction = createAsyncThunk(
  'LIST_PHOTO_ALBUM_REQUEST',
  async (payload: ListPhotoAlbumRequestModel) => listPhotoAlbum(payload),
);

export const createPhotoAlbumAction = createAsyncThunk(
  'CREATE_PHOTO_ALBUM_REQUEST',
  async (payload: SavePhotoAlbumRequestModel, { rejectWithValue }) => {
    try {
      return await createPhotoAlbum(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updatePhotoAlbumAction = createAsyncThunk(
  'UPDATE_PHOTO_ALBUM_REQUEST',
  async (payload: SavePhotoAlbumRequestModel, { rejectWithValue }) => {
    try {
      return await updatePhotoAlbum(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deletePhotoAlbumAction = createAsyncThunk(
  'DELETE_PHOTO_ALBUM_REQUEST',
  async (payload: DeletePhotoAlbumRequestModel, { rejectWithValue }) => {
    try {
      return await deletePhotoAlbum(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactivePhotoAlbumAction = createAsyncThunk(
  'INACTIVE_PHOTO_ALBUM_REQUEST',
  async (payload: InactivePhotoAlbumRequestModel, { rejectWithValue }) => {
    try {
      return await inactivePhotoAlbum(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activePhotoAlbumAction = createAsyncThunk(
  'ACTIVE_PHOTO_ALBUM_REQUEST',
  async (payload: ActivePhotoAlbumRequestModel, { rejectWithValue }) => {
    try {
      return await activePhotoAlbum(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
